export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0; // Generate a random integer between 0 and 15
    const value = char === 'x' ? random : (random & 0x3) | 0x8; // Set the variant bits for `y`
    return value.toString(16); // Convert to hexadecimal
  });
}
